import {
  axios,
  getConfigs,
  IRequestConfig,
  FindMultistepProtocolsQuery,
  CreateMultistepProtocolDto,
  MultistepProtocolDto,
} from './api'

export class MultistepProtocolService {
  private static basePath = process.env.REACT_APP_API_URL

  static findAll(
    query?: FindMultistepProtocolsQuery,
  ): Promise<MultistepProtocolDto[]> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + '/multistep-protocol'
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        {},
      )
      configs.params = query
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  static findOne(id: number): Promise<MultistepProtocolDto> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + `/multistep-protocol/${id}`
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        {},
      )
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  static create(
    dto: CreateMultistepProtocolDto,
  ): Promise<MultistepProtocolDto> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + '/multistep-protocol'
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static update(
    id: number,
    dto: Partial<CreateMultistepProtocolDto>,
  ): Promise<MultistepProtocolDto> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + `/multistep-protocol/${id}`
      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        url,
        {},
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static remove(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const url = this.basePath + `/multistep-protocol/${id}`
      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        url,
        {},
      )
      configs.data = null
      axios(configs, resolve, reject)
    })
  }
}
